(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memeem-collection-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memeem-collection-browser')) {
    customElements.define('memeem-collection-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const tree = window.MemeemCategoryTreeData || [];
        const handle = this.dataset.handle;
        const find = (nodes, path = []) => {
          for (const node of nodes) {
            const next = [...path, node];
            if (node.h === handle) return next;
            const found = find(node.c || [], next);
            if (found) return found;
          }
        };
        const path = find(tree);
        if (!path && handle !== 'all') return;
        this.dataset.ready = 'true';
        const current = path?.at(-1);
        const parent = path?.at(-2);
        const makeLink = (node, className) => {
          const link = document.createElement('a');
          link.href = '/collections/' + encodeURIComponent(node.h);
          link.className = className;
          link.textContent = node.t;
          return link;
        };
        if (path) {
          const breadcrumb = this.querySelector('[data-department-breadcrumb]');
          const home = breadcrumb.firstElementChild;
          breadcrumb.replaceChildren(home);
          for (const [index, node] of path.entries()) {
            const separator = document.createElement('span');
            separator.textContent = '/';
            separator.setAttribute('aria-hidden', 'true');
            const item = index === path.length - 1 ? document.createElement('span') : makeLink(node, '');
            item.textContent = node.t;
            if (index === path.length - 1) item.setAttribute('aria-current', 'page');
            breadcrumb.append(separator, item);
          }
        }
        const parentLink = this.querySelector('[data-department-parent]');
        if (parent) {
          parentLink.href = '/collections/' + encodeURIComponent(parent.h);
          parentLink.textContent = '← ' + parent.t;
        }
        const items = current?.c?.length ? current.c : parent?.c || tree;
        const categories = this.querySelector('[data-department-categories]');
        for (const node of items) {
          if (node.h === handle) continue;
          const link = makeLink(node, 'mm-department__category');
          const label = document.createElement('span');
          label.textContent = node.t;
          link.replaceChildren(label);
          if (node.i) {
            const image = document.createElement('img');
            image.src = node.i;
            image.alt = '';
            image.width = 88;
            image.height = 72;
            image.loading = 'lazy';
            link.prepend(image);
          }
          categories.append(link);
        }
        if (categories.children.length) {
          const navigation = this.querySelector('[data-department-navigation]');
          if (!current?.c?.length) this.querySelector('[data-department-heading]').textContent = this.dataset.labels;
          navigation.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
